<template>
    <div class="footer">
        <div class="content">
            <div class="logo">
                <img src="../../../../img/logo/ugt_logo.png" />
                <p>União Geral dos Trabalhadores<br>
                    do Estado de São Paulo - UGT</p>
            </div>
            <nav class="institutional">
                <ul>
                    <h3>Institucional</h3>
                    <li><a href="/institucional/carta-de-tupa">Carta de Tupã</a></li>
                    <li><a href="/institucional/diretoria">Diretoria</a></li>
                    <li><a href="/institucional/historia">História</a></li>
                    <li><a href="/institucional/valores">Missão, Visão e Valores</a></li>
                    <li><a href="/institucional/presidente">Presidente</a></li>
                </ul>
            </nav>
            <nav class="news">
                <ul>
                    <h3>Notícias</h3>
                    <li><a href="/noticias/noticias-ugt">UGT - SP Notícias</a></li>
                    <li><a href="/noticias/palavra-do-presidente">Palavra do Presidente</a></li>
                    <li><a href="/noticias/comentario-do-diretor">Comentário do Diretor</a></li>
                </ul>
            </nav>
            <nav class="contact">
                <ul class="items">
                    <h3><a href="/contato">Contatos</a></h3>
                    <li><a target="_blank" class="ext-link" href="https://api.whatsapp.com/send?phone=5511994926889">(11) 99492‑6889 (Sede São Paulo - Capital)</a></li>
                    <li><a target="_blank"  class="ext-link" href="tel:+55 11 48016920">(11) 4801-6920 (Sede São Paulo - Capital)</a></li>
                    <li><a target="_blank" class="ext-link" href="https://api.whatsapp.com/send?phone=5514991162465">(14) 99116-2465 (Sede Tupã - Interior)</a></li>
                    <li>E-mail geral: <a href="mailto:ugtsp@terra.com.br" class="ext-link">ugtsp@terra.com.br</a></li>
                    <li>E-mail financeiro: <a class="ext-link" href="mailto:financeiro@ugt-sp.org.br">financeiro@ugt-sp.org.br</a></li>
                    <li class="social">
                        <a href="https://twitter.com/sp_ugt" target="_blank" class="social-link">
                            <svg-icon icon="twitter"></svg-icon>
                        </a>
                        <a href="https://www.facebook.com/ugtsp" target="_blank" class="social-link">
                            <svg-icon icon="facebook"></svg-icon>
                        </a>
                        <a href="https://youtube.com/channel/UCeMrGI2nKGKFQWQ0DEIUUVg" target="_blank" class="social-link">
                            <svg-icon icon="youtube"></svg-icon>
                        </a>
                        <a href="/sistema" class="social-link">
                            <svg-icon icon="tv"></svg-icon>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
        <p class="text-white text-center py-10">&copy 2021 UGT SP - Todos os direitos reservados</p>
    </div>
</template>

<script>
 export default {
     name: 'main-footer',
 }
</script>

<style lang="scss" scoped>
.footer{
    background-image: url("../../../../img/bg/bg-footer.png");
    background-repeat: repeat-x;
    .content {
        @media(max-width: 699px) {
            max-width: 300px;
            @apply mx-auto flex flex-wrap py-4;
            a, li {
                @apply text-white list-none;
            }
            h3{
                @apply text-primary mb-2;
            }
            .logo {
                @apply text-white mx-auto;
                img {
                    max-width: 130px;
                    margin: 0 auto 20px auto;
                }
            }
            .social {
                @apply flex items-center justify-between py-4;
                .social-link {
                    @apply text-white;
                    width: 20px;
                    height: 20px;
                }
            }
        }
        @media (min-width: 700px) {
            @apply mx-auto p-8 flex justify-between;
            max-width: 1080px;
            a, li {
                @apply text-white list-none;
            }
            h3{
                @apply text-primary mb-2;
            }
            .logo {
                @apply text-white text-center;
                img {
                    max-width: 130px;
                    margin: 0 auto 20px auto;
                }
            }
            .social {
                @apply flex items-center justify-between py-4;
                .social-link {
                    @apply text-white;
                    width: 28px;
                    height: 28px;
                }
                .social-link:hover{
                    @apply text-secondary;
                }
            }
        }
        .ext-link {
            @apply text-white;
        }
        .ext-link:hover {
            @apply text-secondary;
        }
    }
    @apply bg-black w-full;
    border-top: 64px solid #e6242c;
    .contact {
        h3, a {
            @apply text-primary;
        }
    }
    a:hover, {
        @apply text-secondary;
    }
}
</style>
